export const GET_LECTURES = 'GET_LECTURES'
export const GET_LECTURE_DETAIL = 'GET_LECTURE_DETAIL'
